<template>

    <v-card>
    
       <v-card>
        <div class="text-center">
            <v-row align="center" style="height: 120px">
                <v-col  cols="12" sm="6" md="4">
                    <v-btn color="primary" @click="carga">Consultar</v-btn>
                    <v-btn v-if="isTester" color="success" @click="dialogCarga=true">Cargar Archivo</v-btn>
               </v-col>
            </v-row>
        </div>
       </v-card>

       <v-dialog v-model="dialogCarga" max-width="450px">
          <v-card color="blue-grey darken-3" dark>
                <v-card-title class="headline"> Cargar Archivo</v-card-title>
                <v-card-text class="pa-4">
                  <v-container>
                  <v-col cols="12" sm="12" >
                      <v-text-field 
                      v-model="editedItem.Namefile" 
                      label="Nombre del Archivo (.pdf)"
                      prepend-icon="mdi-file"
                      dense
                      ></v-text-field>
                  </v-col>
                </v-container>
                  <v-col  cols="12" sm="12" >
                    <v-container>
                        <template>
                        <v-file-input v-model="editedItem.files"
                            accept=".pdf"
                            label="Archivo pdf"
                            placeholder="Seleccione su archivo"
                            name="file"  
                            id="file"
                            class="mb-3"
                            dense
                            :rules="filerules"
                        ></v-file-input>
                        </template>
                </v-container>
                </v-col>
                <v-container>
                <v-col cols="12" sm="12">
                    <v-menu
                                v-model="menu3"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="editedItem.start_dt"
                                    label="Fecha Inicio"
                                    prepend-icon="mdi-calendar-today"
                                    :rules="fechaRule"
                                    readonly
                                    required
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mb-3"
                                    dense
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="editedItem.start_dt" @input="menu3 = false"></v-date-picker>
                                
                            </v-menu>
                        </v-col>
                      </v-container>
                      <v-container>
                        <v-col cols="12" sm="12">
                            <v-menu v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="200px"
                            >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="editedItem.end_dt"
                                    label="Fecha Fin"
                                    prepend-icon="mdi-calendar-today"
                                    :rules="fechaRule"
                                    readonly
                                    required
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mb-3"
                                    ></v-text-field>
                            </template>
                            <v-date-picker v-model="editedItem.end_dt" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                  </v-container>
                </v-card-text>
                    <v-card-actions class="justify-end">
                    <v-spacer></v-spacer>
                        <v-btn color="error" @click="dialogCarga=false">Cancelar</v-btn>
                        <v-btn color="success" @click="cargararchivo()">Aceptar</v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>

             
      <v-container fluid>
        <v-card>
         <v-card-title>
           <v-icon x-large>mdi-clipboard-list-outline</v-icon>Listado Politica Entrega a CD
           <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Filtro"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
        :headers="headers"
        :items="mvm"
        :search="search"
        sort-by="calories"
        class="elevation-1"
      >
      
      <!-- Slot para la columna de Ver -->
      <template v-slot:item.view="{ item }">
        <v-btn
          small
          color="blue"
          outlined
          @click="viewDocument(item.idfile)"
        >
          <v-icon left>mdi-eye</v-icon>
          Ver
        </v-btn>
      </template>

      </v-data-table>
      </v-card>
      </v-container>
      <v-spacer></v-spacer>
    
      <v-dialog v-model="dialog_new" max-width="900px">
      <v-stepper v-model="e1" vertical>
             <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
            <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">{{ this.step_txt1 }}
                <small>{{this.step_txt2}}</small>
            </v-stepper-step>
            <v-stepper-content step="1">
            <v-card height="100px">
                <div class="text-center">
                <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
                {{this.msj_proceso}}
                </div>
            </v-card>
            </v-stepper-content>  
        </v-stepper>
      </v-dialog>

      <!-- Dialogo para ver el PDF -->
      <v-dialog v-model="dialogpdf" max-width="800px" >
        <v-card>
          <v-card-title>
        <!-- Botón de cierre (X) en la parte superior derecha -->
            <v-spacer></v-spacer>
            <v-btn
              @click="dialogpdf = false"
              color="primary"
              absolute
              top
              right
              icon
              class="close-btn"
            >
            <v-icon>mdi-close</v-icon> <!-- Icono X -->
            </v-btn>
          </v-card-title>
          <v-card-text class="d-flex align-center justify-center" style="height: 800px;">
          <!-- Canvas para mostrar el PDF -->
            <iframe ref="pdfIframe" :src='this.url' 
            width="700" height="750" frameborder="0"
            ></iframe>
         
          </v-card-text>

      </v-card>
    </v-dialog>
    </v-card>
    </template>
    
    <script>
    import axios from 'axios'
    //import Vue from "vue";
    //import JsonExcel from "vue-json-excel";
    import XLSX from 'xlsx';
     
    //Vue.component("downloadExcel", JsonExcel);
    
    export default {
      data: () => ({
        url:'',
        search: '',
        search2: '',
        api_tool_url: process.env.VUE_APP_API_TOOL_URL,
        dialog: false,
        dialogCarga: false,
        dialog_pass: false,
        dialog_new: false,
        dialog_detail: false,
        dialogpdf:false,
        valid: true,
        menu: false,
        menu2: false,
        menu3: false,
        e1: 0,
        btnap:true,
        btn: false,
        msj_proceso:'',
        msj_pdf:'',
        progressBar1: false,
        progressBar: false,
        progressBarPDF: false,
        overlay: false,
        step_error1: true,
        step_error2: true,
        step_error3: true,
        step_color1:"primary",
        step_color2:"primary",
        step_color3:"primary",
        RequestProposal_id:'',
        step_txt1:'',
        step_txt2:'',
        isTester: false,
        headers: [
          { text: 'id', value: 'idfile' },
          { text: 'Nombre', value: 'Namefile' },
          { text: 'Fecha Inicio', value: 'EffectiveDate' },
          { text: 'Fecha Fin', value: 'ExpirationDate' },
          { text: 'Usuario', value: 'ApiUser_id'},
          { text: "Ver", value: "view", sortable: false }, // Columna para botón Ver
                   
        ],
        mvm: [],
        editedIndex: -1,
        editedItem: {
        start_dt: new Date().toISOString().substr(0, 10),
        end_dt: new Date().toISOString().substr(0, 10),
        Namefile: '',
        fecha: new Date().toISOString().substr(0, 10),
        files: []
       },
      
        filerules: [
        value => !!value || 'El Archivo es requerido'
        
        ],
               
        fechaRule: [
            v => !!v || 'Fecha es requerida'
        ],
        datoRule: [
            v => !!v || 'El dato es Requerido'
           
        ],
        
        config: {
          headers: {
            //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
            "api-user": sessionStorage.getItem('ApiUser_id')
          }
        }
      }),
    
      computed: {
        formTitle () {
          return this.editedIndex === -1 ? 'Nuevo Planning' : 'Editar Planning'
        }
      },
    
      watch: {
        dialog (val) {
          val || this.close()
        }
      },
      created () {
        this.$store.commit('updateTitle', 'Condicion de Entrega')
        this.initialize()
      },
    
      methods: {
        initialize () {
            let usertype = this.$store.state.ApiUserType_id
            console.log(usertype)
            if(usertype === 'R' ){
            this.isTester = false;
            }else{
            this.isTester = true;
            }
            
        },
        viewDocument(idfile){
          console.log(idfile)
          this.step_txt1="Consultando PDF"
          this.step_txt2=""
          this.dialog_new = true
          this.e1 = 1
          this.progressBar = true
          this.step_error1 = true
          this.step_error2 = true
          this.step_error3 = true
          this.step_color1 = "primary",
          this.step_color2 = "primary",
          this.step_color3 = "primary",
          this.msj_proceso = "Por favor aguarde un momento ¡No cerrar esta ventana!"
          let data = new FormData()
          data.append('foo', 'bar');
          data.append('idfile', idfile);
          
          axios.post(this.api_tool_url + '/get_viewdocument', data, this.config)
                .then(response => {
                        if( response.data.ResultRows.length >= 1) {
                            
                            this.dialog_new = false
                            this.dialogpdf = true
                            if(this.dialogpdf){
                              this.url = 'data:application/pdf;base64,'+response.data.ResultRows[0]['Politicsfile']
                            }
                        }
                        else {
                          this.step_txt1="Ocurrio un error"
                          this.e1 = 1
                          this.step_color1 = "#C0392B"
                          this.progressBar = false
                          this.msj_proceso = response.data.error
                        }
                        
                    })
                    .catch(error => {
                      this.step_txt1="Ocurrio un error"
                      this.step_error1 = false
                      this.progressBar = false
                      this.msj_proceso = error.message
                    })

        },
        carga() {
                  this.step_txt1="Consultando Datos"
                  this.step_txt2=" "
                  this.dialog_new = true
                  this.e1 = 1
                  this.progressBar = true
                  this.step_error1 = true
                  this.step_error2 = true
                  this.step_error3 = true
                  this.step_color1 = "primary",
                  this.step_color2 = "primary",
                  this.step_color3 = "primary",
                  this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
                  this.mvm = []
     
                axios.post(this.api_tool_url + '/get_politics', {}, this.config)
                .then(response => {
                        //if(response.data.ResultRows.length >= 1) {
                        if(response.data && response.data.ResultRows && response.data.ResultRows.length >= 1) {

                            this.mvm = response.data.ResultRows
                            this.e1 = 1
                            this.step_color1 = "#008000"
                            this.progressBar = false
                            this.msj_proceso = 'Se realizo consulta correctamente.'
                            this.active = false  
                        }
                        else {
                          this.step_txt1="Ocurrio un error"
                          this.e1 = 1
                          this.step_color1 = "#C0392B"
                          this.progressBar = false
                          this.msj_proceso = response.data.error
                            
                        }
                        
                    })
                    .catch(error => {
                      this.step_txt1="Ocurrio un error"
                      this.step_error1 = false
                      this.progressBar = false
                      this.msj_proceso = error.message
                    })
                    
                    
              },
              
        
          cargararchivo() {
            //this.btn = true
            this.dialogCarga = false
            this.step_txt1="Realizando carga de archivo"
            this.step_txt2=" "
            this.dialog_new = true
            this.e1 = 1
            this.progressBar = true
            this.step_error1 = true
            this.step_error2 = true
            this.step_error3 = true
            this.btnap=true
            this.step_color1 = "primary",
            this.step_color2 = "primary",
            this.step_color3 = "primary",
            this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
            let data = new FormData();
            //this.mvm = []
            data.append('foo', 'bar');
            data.append('file', document.getElementById('file').files[0]);
            data.append('user', sessionStorage.getItem('ApiUser_id'));
            data.append('namefile', this.editedItem.Namefile);
            data.append('start_dt', this.editedItem.start_dt);
            data.append('end_dt', this.editedItem.end_dt);


          axios.post(this.api_tool_url + '/fileUpload_politicsCD', data, this.config)
          .then(response => {
                  //if(response.data.ResultRows.length >= 1) {
                  if(response.data && response.data.ResultRows && response.data.ResultRows.length >= 1) {

                      //this.mvm = response.data.ResultRows
                      //this.id_process = response.data.Proceso_id                          
                      this.e1 = 1
                      this.step_color1 = "#008000"
                      this.progressBar = false
                      this.msj_proceso = 'Se realizo la carga del archivo correctamente.'
                      //this.carga();
                      this.editedItem.Namefile = ''
                      this.editedItem.files = []
                      this.editedItem.start_dt = new Date().toISOString().substr(0, 10)
                      this.editedItem.end_dt = new Date().toISOString().substr(0, 10)
                  }
                  else {
                      this.step_txt1="Ocurrio un error"
                      this.e1 = 1
                      this.step_color1 = "#C0392B"
                      this.progressBar = false
                      this.msj_proceso = response.data.error
                  }
                  
              })
              .catch(error => {
                  this.step_txt1="Ocurrio un error"
                  this.step_error1 = false
                  this.progressBar = false
                  this.msj_proceso = error.message
                  
              })
         
        },
        close () {
          this.dialog_new = false
          this.dialogCarga = false
          this.dialogpdf = false
        },
        close2 () {
          this.dialog_detail= false
        },
    
        close() {
            this.dialog_new = false
        },
      }
    }
    </script>

<style>
.custom-450px {
  width: 80%;
  
}


</style>



// WEBPACK FOOTER //
// src/components/DeliveryCondition.vue